import React from "react";
import PlatformCard from "./PlatformCard";
import "./PlatformGrid.css";

/**
 * A-009A — Renders platforms[] from the canonical payload.
 */
function PlatformGrid({ platforms }) {
  const list = Array.isArray(platforms) ? platforms : [];

  if (!list.length) {
    return (
      <p className="platform-grid__empty">
        Platform availability will appear here soon.
      </p>
    );
  }

  return (
    <div className="platform-grid">
      {list.map((platform) => (
        <PlatformCard key={platform.slug || platform.name} platform={platform} />
      ))}
    </div>
  );
}

export default PlatformGrid;
